/**
 * 1stdibs
 * User: Rob
 * Date: 8/22/13
 */
"use strict";
/**
 * @mixes bunsen.SoaCollection
 * @class
 * @property {bunsen.Offer} model - {@link bunsen.Offer}
 * @property {endpoints.offers} url -
 */
var SoaCollection = require('bunsen/collections/SoaCollection');
var root = typeof window === 'undefined' ? global : window;
var Notes = module.exports = root.bunsen.Notes = SoaCollection.extend();


/**
 * @class Notes
 * @extends SoaCollection
 */

var endpoints     = require('dibs-endpoints');
var Note          = require('bunsen/models/Note');
var moment        = require('moment');
var User          = require('bunsen/models/identity/User');
var _             = require('underscore');
var $             = require('dibs-jquery-shim');
var Party         = require('bunsen/models/Party');

var filterNoteByFn = function (fn) {
    return this.filter(function (note) {
        return note[fn]();
    });
};

root.bunsen = root.bunsen || {};

_.extend(Notes, {
    /**
     * Create a new Note instance
     * @param {object} [options]
     * @param {string} [options.role=INTERNAL]
     * @param {string} [options.type=ADMIN]
     * @param {string} [options.level=INFO]
     * @param {string|number} [options.creatorId] Defaults to current user id
     * @param {string} [options.content] Defaults to empty string
     * @param {anchors} [options.anchors] Defaults to empty array
     * @returns {Note}
     */
    newNote: function (options) {
        var user = User.getCurrentUserSV() || {};
        options = _.defaults(options || {}, {
            role: Party.ROLE_INTERNAL,
            type: Note.TYPE_ADMIN,
            level: 'INFO',
            creatorId: user.id,
            content: '',
            service: endpoints.latest.identity
        });

        return new Note({
            type: options.type,
            content: options.content,
            level: options.level,
            anchors: options.anchors,
            createdBy: {
                role: options.role,
                id: options.creatorId
            }
        }, {
            service: options.service
        });
    },
    /**
     * Partial application of newNote that defaults
     * the note role and sets the type to BUYER_SELLER
     * @param {object} [newNoteOptions]
     *      Same as Note.newNote options except for role and type
     * @param {string} [newNoteOptions.role=SELLER]
     * @param {string} [newNoteOptions.level=INFO]
     * @param {string|number} [newNoteOptions.creatorId] Defaults to current user id
     * @param {string} [newNoteOptions.content] Defaults to empty string
     * @param {anchors} [newNoteOptions.anchors] Defaults to empty array
     * @returns {Note}
     */
    newBuyerSellerNote: function (newNoteOptions) {
        newNoteOptions = _.extend({
            role: Party.ROLE_SELLER
        }, newNoteOptions, { type: Note.TYPE_BUYER_SELLER });
        return Notes.newNote(newNoteOptions);
    }
});

_.extend(Notes.prototype, {
    model: Note,
    url : endpoints.note(null, this.service),
    initialize : function (models, options) {
        this.service = options.service || endpoints.latest.identity;
        return Notes.__super__.initialize.call(this, models, options);
    },
    comparator: function (note) {
        return parseInt(moment(new Date(note.get("createdDate"))).format("X"), 10) || -1;
    },
    getOldest : function () {
        var oldest;
        if (moment) {
            this.each(function (note) {
                if (!oldest || parseInt(moment(new Date(oldest.get('createdDate'))).format('X'), 10) > parseInt(moment(note.get('createdDate')).format('X'), 10)) {
                    oldest = note;
                }
            });
        }
        return oldest;
    },
    getBuyerSellerNotes: _.partial(filterNoteByFn, 'isBuyerSellerType'),
    getUnanchoredBuyerSellerNotes: _.partial(filterNoteByFn, 'isUnanchoredBuyerSellerType'),
    /**
     * Get the FIRST note in the collection which was created
     * by someone matching the passed in role
     * @param role
     * @returns {*}
     */
    getByCreatorRole : function (role) {
        return this.find(function (note) {
            return note.get('createdBy') && note.get('createdBy.role') === role;
        });
    },

    fetchNotesByAnchor : function (anchor, options) {
        var fetchOptions = {
            url: endpoints.notesByAnchor(anchor)
        };

        _.extend(fetchOptions, options);

        return this.fetch(fetchOptions);
    },
    /**
     * Fetch the anchor models from the id (e.g. fetch a seller model
     * for the anchor with the sourceType seller) and store them
     * on the inflatedAnchors property of each Note model in the collection
     * @param sourceTypes
     * @returns {$.promise}
     */
    fetchAnchors : function (sourceTypes) {
        var dfd = $.Deferred();
        var len = this.length;
        var proms = [];
        var i = -1;
        var self = this;

        while (++i < len) {
            proms.push(this.models[i].fetchAnchors(sourceTypes));
        }
        $.when.apply($, proms).done(function () {
            dfd.resolveWith(self, _.toArray(arguments));
        }).fail(function () {
            dfd.rejectWith(self, _.toArray(arguments));
        });
        return dfd.promise();
    },
    newNote: function (passedOptions) {
        return Notes.newNote(passedOptions);
    },
    newBuyerSellerNote: function (newNoteOptions) {
        return Notes.newBuyerSellerNote(newNoteOptions);
    },
    addNewNote: function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.add(note);
        return note.save(null, syncOptions);
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/Notes.js
// module id = 24
// module chunks = 64